import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import { SelectAllBanks } from "../OfflineDb/IndexDbTranscSP";
import AlertModal from "../CommonControlls/AlertModal";
import DropDown from "../CommonControlls/DropdownRendrer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
    return store;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};

class RiderPayments extends Component {
    constructor(props) {
        super(props);

        this.monthRef = React.createRef();

        this.state = {
            // Table
            data: [],
            page: 1,
            sizePerPage: 2000,
            TotalRecord: 0,
            loading: false,
            exportLoading: false,

            sortField: "id",
            idsortOrder: "desc",
            provinceNamesortOrder: "",
            districtNamesortOrder: "",

            permissions: [],

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: [],

            BatchLoader: false,
            Batchlist: [],
            BatchId: '',

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],
            DistrictId: [],

            TehsilLoader: false,
            Tehsillist: [],
            FilteredTehsillist: [],
            TehsilId: [],

            RiderLoader: false,
            Riderslist: [],
            SrList: [],
            SrId: [],
            FilteredSrs: [],
            RiderId: 0,
            riderInfo: "",

            startDate: new Date(),
            endDate: new Date(),

            Banklist: [],
            BankId: 0,
            BankLoader: false,

            selectedFile: null
        };
    }

    HandleDateChange = (Field, date) => {
        this.setState(
            { [Field]: date === "" || date == null ? new Date() : date },
            () => {
                if (
                    Field === "startDate" &&
                    this.state.startDate > this.state.endDate
                ) {
                    this.setState({ endDate: this.state.startDate });
                }
            }
        );
    };

    HandleSubmit = () => {
        const { selectedFile } = this.state;

        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('month', this.monthRef.current.value);
            formData.append('batch', this.state.BatchId);

            // Include Authorization header in the request
            fetch(Common.APILinks.RiderPayments_BankUpload, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.props.UserAuthentication.AuthToken}`, // Include your authorization token here
                },
                body: formData,
            })
                .then(response => response.json())
                .then(result => {
                    this.setState({
                        Riderslist: result.data,
                        RiderLoader: false,
                    });

                    this.props.ShowAlert({
                        Type: 1,
                        Msg: "File uploaded and processed successfully",
                    });

                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                })
                .catch(error => {
                    this.setState({
                        Riderslist: [],
                        RiderLoader: false,
                    });

                    this.props.ShowAlert({
                        Type: 0,
                        Msg: "Error sending CSV file",
                    });

                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);

                });

        } else {
            console.warn('No file selected.');
        }
    };

    HandleFileChange = (event) => {
        const file = event.target.files[0];
        this.setState({ selectedFile: file });
    };

    HandleMonthChange = () => {
        this.SelectBatches();
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        console.log(fieldId)
        console.log(value)
        this.setState(
            {
                [fieldId]: value,
                // isSaveSearch: this.state.isSearchChanged ? true : false
            }
        );
    };

    SelectRiders = () => {
        this.setState({ RiderLoader: true });

        var provinceId =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtId =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilId =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";

        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.Select_MultipleRiderProfiles,
            {
                sortField: "id",
                sortOrder: "asc",
                provinceId,
                districtId,
                tehsilId,
            },
            (response) => {
                this.setState({
                    Riderslist: response.data,
                    RiderLoader: false,
                });
            }
        );
    };
    FilterDistricts = (value) => {
        // filter ditrict list
        var TempArr = this.state.Districtlist;
        var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
        var filteredDistrictList = TempArr.filter(function (obj) {
            return selectedProvince.indexOf(obj.provinceId) > -1;
        });

        // filter district selected values
        var selectedDistricts = this.state.DistrictId;
        var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(
            filteredDistrictList,
            "id"
        );
        var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
            return filteredDistrictIdArr.indexOf(obj.id) > -1;
        });

        const TempSr = this.state.SrList;
        const filtered = TempSr.filter((el) => {
            return selectedProvince.indexOf(el.provinceid) > -1;
        });

        this.setState({
            FilteredSrs: filtered,
            FilteredDistrictlist: filteredDistrictList,
            DistrictId: filteredSelectedDistricts,
        });
    };
    FilterTehsils = (value) => {
        // filter Tehsil list
        var TempArr = this.state.Tehsillist;
        var selectedVale = Common.ConvertToCommaSplitArray(value, "id");
        var filteredTehsilList = TempArr.filter(function (obj) {
            return selectedVale.indexOf(obj.districtId) > -1;
        });

        // filter Tehsil selected values
        var selectedTehsils = this.state.TehsilId;
        var filteredTehsilIdArr = Common.ConvertToCommaSplitArray(
            filteredTehsilList,
            "id"
        );
        var filteredSelectedTehsils = selectedTehsils.filter(function (obj) {
            return filteredTehsilIdArr.indexOf(obj.id) > -1;
        });

        this.setState({
            FilteredTehsillist: filteredTehsilList,
            TehsilId: filteredSelectedTehsils,
        });
    };

    render() {
        function avatarformatter(cell, row) {
            return <span>{row.name}</span>;
        }

        const columns = [
            {
                dataField: "provinceName",
                text: "Province",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
            },
            {
                dataField: "subRecipient_ShortName",
                text: "SR",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "90px", fontSize: "13px" };
                },
            },
            {
                dataField: "districtName",
                text: "District",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "90px", fontSize: "13px" };
                },
            },
            {
                dataField: "riderName",
                text: "Rider",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "riderType",
                text: "Rider Type",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
            },
            {
                dataField: "riderContact",
                text: "Rider Contact",
                sort: true,
                export: true,
            },
            {
                dataField: "riderCnic",
                text: "CNIC",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "completedJobs",
                text: "Completed Jobs",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "deliveredSamples",
                text: "Delivered Samples",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "distanceTraveled",
                text: "Distance Traveled",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "incentiveEarned",
                text: "Incentive Amount",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "120px", fontSize: "13px" };
                },
            },
            {
                dataField: "wht",
                text: "WHT @ 8%/4%",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "gst",
                text: "GST @ 5%",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "80px", fontSize: "13px" };
                },
            },
            {
                dataField: "totalTax",
                text: "Total Tax",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "netPayable",
                text: "Net Payable",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "filerStatus",
                text: "Filer Status",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "bankName",
                text: "Bank Name",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "imdCode",
                text: "IMD Code",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "bankStatus",
                text: "Bank Status",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
            },
            {
                dataField: "accountNumber",
                text: "Final IBAN Remarks",
                sort: true,
                export: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "200px", fontSize: "13px" };
                },
            }

        ];
        return (
            <div>
                <AlertModal {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" className="right-panel">
                    <Topmenu
                        PageTitle="Finance"
                        isShowAddBtn={this.state.permissions.includes("riderprofiles-add")}
                        AddBtnLabel=""
                        AddBtnLink=""
                    />
                    <div className="content">
                        <div
                            className="card"
                            style={{
                                marginBottom: "20px",
                                background: "none",
                                boxShadow: "none",
                            }}
                        >
                            <div className="card-body row" style={{ padding: "0px" }}>
                                <div className="widget-tabs-list">
                                    <ul className="Cases-nav nav nav-tabs">
                                        <li>
                                            {" "}
                                            {this.state.permissions.includes("jobhistory-view") && (
                                                <Link data-toggle="tab" to="/RiderIncentives" className="active">
                                                    Rider Incentives
                                                </Link>
                                            )}
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="Table_Search row">
                                    <div className="formInput_Container col-lg-3 col-md-2 col-sm-12 col-xs-12">
                                        <label htmlFor="">Month</label>
                                        <div className="form-group">
                                            <label htmlFor="staticEmail2" className="sr-only">Month</label>
                                            <input
                                                type="month"
                                                id="month"
                                                className="form-control"
                                                onChange={this.HandleMonthChange}
                                                placeholder="Month"
                                                ref={this.monthRef}
                                            />
                                        </div>
                                    </div>
                                    <div className="formInput_Container col-lg-3 col-md-2 col-sm-12 col-xs-12">
                                        <label htmlFor="">Batch</label>
                                        <DropDown
                                            multi={false}
                                            dropdownRenderer={true}
                                            create={false}
                                            onChange={this.HandleAutoSuggestValChange}
                                            Type="BatchId"
                                            options={this.state.Batchlist}
                                            val={this.state.BatchId}
                                            addPlaceholder=""
                                            disabled={false}
                                            loading={this.state.BatchLoader}
                                            searchBy="name"
                                            labelField="name"
                                            valueField="id"
                                            contentRenderer={true}
                                            placeholder="Select"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <button
                                            style={{ position: "relative", marginTop: 35 }}
                                            onClick={() => {
                                                this.PopulateTable();
                                            }}
                                            id="FormSearchBtn"
                                            className="btn btn_style1"
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>

                                <h4>Upload Bank File</h4>
                                <hr />
                                {this.state.TotalRecord > 0 ?
                                    (
                                        <div className="Table_Search row">
                                            <div className="formInput_Container col-lg-3 col-md-2 col-sm-12 col-xs-12">
                                                <label htmlFor="">File</label>
                                                <div className="form-group">
                                                    <label htmlFor="staticEmail2" className="sr-only">File</label>
                                                    <input type="file" accept=".csv" onChange={this.HandleFileChange} className="form-control" />
                                                </div>
                                            </div>

                                            <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                                <label htmlFor="">&nbsp;</label>
                                                <button
                                                    onClick={() => {
                                                        this.HandleSubmit();
                                                    }}
                                                    id="UploadFileBtn"
                                                    className="btn success"
                                                >
                                                    Upload
                                                </button>
                                            </div>
                                        </div>
                                    ) : (<span className="alert alert-info" style={{ lineHeight: "5em" }}>Select a month and batch to upload</span>)
                                }

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.ExportData();
                                        }, 100);
                                    }}
                                    exportPdf={this.ExportPdf}
                                    isPagination={true}
                                    exportLoading={this.state.exportLoading}
                                    pdfExportLoading={this.state.pdfExportLoading}
                                    columns={columns}
                                    exportAllowed={this.state.permissions.includes(
                                        "riderprofiles-export"
                                    )}
                                    loading={this.state.loading}
                                    RefreshTable={this.PopulateTable}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    //componentWillMount() {

    //}

    componentDidMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login");
        }

        Common.AddClassToMenueLink(
            "MenuLink_RiderPayments",
            true,
            "MenuParentLink_Finance"
        );

        this.GetPageConfigData(() => {
            this.PopulateTable();
        });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_RolesPermissions,
            {},
            (resp) => {
                const modifiedPermissions = resp.data
                    .filter(
                        (p) => p.permissioN_GROUP === "RiderJobs" && p.permissioN_ALLOWED
                    )
                    .map((d) => d.permissioN_NAME);
                this.setState({ permissions: modifiedPermissions });
            }
        );
        this.SelectSubReciepents();
    }

    SelectSubReciepents = () => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectALl_SubRecipient,
            {},
            (resp) => {
                if (resp.status) {
                    this.setState({
                        SrList: resp.data.map((d) => ({
                            id: d.id,
                            name: d.short_name,
                            ...d,
                        })),
                    });
                }
            }
        );
    };

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true });
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        var d4 = $.Deferred();

        this.SelectProvinces(() => {
            d1.resolve();
        });
        this.SelectDistricts(() => {
            d2.resolve();
        });
        this.SelectTehsil(() => {
            d3.resolve();
        });
        this.SelectAllBanksList(() => {
            d4.resolve();
        });
        $.when(d1, d2, d3, d4).done(() => {
            this.props.ShowLoader({ Isloading: false });
            CallBack();
        });
    };

    SelectBatches = () => {
        this.setState({ BatchLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.RiderIncentives_SelectAll_Batches,
            { month: this.monthRef.current.value },
            (data) => {
                this.setState({
                    BatchLoader: false,
                    Batchlist: data.data,
                });
                //Callback();
            },
            (error) => {
                this.setState({ BatchLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                //Callback();
            }
        );
    };

    SelectProvinces = (Callback) => {
        this.setState({ ProvinceLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Province,
            {},
            (data) => {
                this.setState({
                    ProvinceLoader: false,
                    Provincelist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ ProvinceLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_District,
            {},
            (data) => {
                this.setState({
                    DistrictLoader: false,
                    Districtlist: data.data.sort(Common.compare),
                });
                Callback();
            },
            (error) => {
                this.setState({ DistrictLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectTehsil = (Callback) => {
        this.setState({ TehsilLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Tehsil,
            {},
            (data) => {
                this.setState({
                    TehsilLoader: false,
                    Tehsillist: data.data.sort(Common.compare),
                });
                Callback();
            },
            (error) => {
                this.setState({ TehsilLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectAllBanksList = (Callback) => {
        this.setState({ BankLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_Bank,
            null,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                if (resp.status) {
                    this.setState({
                        BankLoader: false,
                        Banklist: resp.data,
                    });
                    Callback();
                }
            },
            (error) => {
                this.setState({ BankLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };

    ExportPdf = () => {
        const doc = new jsPDF();

        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ pdfExportLoading: true });

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilIdString =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            provinceIdString,
            districtIdString,
            tehsilIdString,
            subRecipientIdString,
            riderId: this.state.RiderId,
            fromDate:
                this.state.startDate == null || this.state.startDate == ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate == ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Select_MultipleRiderProfiles,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                if (resp.status) {
                    doc.autoTable({
                        theme: "grid",
                        body: [...resp.data],
                        columns: [
                            { header: "id", dataKey: "id" },
                            { header: "Name", dataKey: "name" },
                            { header: "Address", dataKey: "address" },
                            { header: "Contact", dataKey: "contact" },
                            { header: "Account #", dataKey: "accountNumber" },
                            { header: "Bank", dataKey: "bankName" },
                            { header: "Province", dataKey: "provinceName" },
                            { header: "Tehsil", dataKey: "tehsilName" },
                            { header: "District", dataKey: "districtName" },
                        ],
                    });

                    this.setState({ pdfExportLoading: false });
                    doc.save("profiles.pdf");
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    ExportData = (size) => {
        //   $('#FormSearchBtn').prop('disabled', true)
        //   this.setState({ exportLoading: true })
        //   var provinceIdString =
        //   this.state.ProvinceId.length === 0
        //     ? ''
        //     : ',' + Common.convertToCommaString(this.state.ProvinceId, 'id') + ','
        //  var districtIdString =
        //   this.state.DistrictId.length === 0
        //     ? ''
        //     : ',' + Common.convertToCommaString(this.state.DistrictId, 'id') + ','
        //  var tehsilIdString =
        //   this.state.TehsilId.length === 0
        //     ? ''
        //     : ',' + Common.convertToCommaString(this.state.TehsilId, 'id') + ','
        //  var subRecipientIdString =
        //   this.state.SrId.length === 0
        //     ? ''
        //     : ',' + Common.convertToCommaString(this.state.SrId, 'id') + ','
        //   var Parameters = {
        //     provinceIdString,
        //     districtIdString,
        //     tehsilIdString,
        //     subRecipientIdString,
        //     fromDate:
        //       this.state.startDate == null || this.state.startDate === ''
        //         ? null
        //         : Common.ConvertToUtcDateTime(
        //           Common.getOnlyDate(this.state.startDate) + ' 00:00:00',
        //         ),
        //     toDate:
        //       this.state.endDate == null || this.state.endDate === ''
        //         ? null
        //         : Common.ConvertToUtcDateTime(
        //           Common.getOnlyDate(this.state.endDate) + ' 23:59:59',
        //         ),
        //     pageSize: this.state.TotalRecord,
        //     pageNumber: 1,
        //     srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
        //     sortField: this.state.sortField,
        //     sortOrder: this.state[this.state.sortField + 'sortOrder'],
        $("#FormSearchBtn").prop("disabled", true);
        //this.setState({ loading: true, data: [], TotalRecord: 0 })
        this.setState({ exportLoading: true });

        var provinceId =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtId =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var tehsilId =
            this.state.TehsilId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.TehsilId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            provinceId,
            districtId,
            tehsilId,
            subRecipientIdString,
            fromDate:
                this.state.startDate == null || this.state.startDate == ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate == ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Select_MultipleRiderProfilesExport,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    if (resp.data.length > 0) {
                        var ProcessedBank = Common.ProcessDataInArray(
                            this.state.Banklist,
                            "id"
                        );
                        for (var i in resp.data) {
                            resp.data[i].bankName =
                                ProcessedBank?.[resp.data[i].bankId]?.name || "";
                            resp.data[i].obj = {
                                amountEarnedFromBeginning:
                                    resp.data[i]?.amountEarnedFromBeginning,
                                amountEarnedWithInDuration:
                                    resp.data[i]?.amountEarnedWithInDuration,
                                avgRating: resp.data[i]?.avgRating,
                                completedJobsCount: resp.data[i]?.completedJobsCount,
                                deliveredSamples: resp.data[i]?.deliveredSamples,
                                rideAVGCost: resp.data[i]?.rideAVGCost,
                                riderDistance: resp.data[i]?.riderDistance,
                                sampleAVGCost: resp.data[i]?.sampleAVGCost,
                            };
                        }
                    }
                    this.setState({
                        data: resp.data,
                        exportLoading: false,
                    });
                    $(".react-bs-table-csv-btn").click();
                    this.PopulateTable();
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };

    handleTableChange = (
        type,
        { page, sizePerPage, filters, sortField, sortOrder, cellEdit }
    ) => {
        if (type == "sort") {
            let tempFieldorderLabel = sortField + "sortOrder";
            let tempFieldorder =
                this.state[tempFieldorderLabel] == ""
                    ? sortOrder
                    : this.state[tempFieldorderLabel] == "asc"
                        ? "desc"
                        : "asc";
            this.setState(
                {
                    sortField,
                    [tempFieldorderLabel]: tempFieldorder,
                },
                () => {
                    this.PopulateTable();
                }
            );
            return;
            // let result = this.state.data
            // // Handle column sort
            // if (sortOrder === 'asc') {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return 1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return -1;
            //     }
            //     return 0;
            //     });
            // } else {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return -1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return 1;
            //     }
            //     return 0;
            //     });
            // }
            // return
        }
        this.setState(
            {
                page,
                sizePerPage,
            },
            () => {
                this.PopulateTable();
            }
        );
    };
    PopulateTable = () => {
        if (!this.monthRef.current) {
            return;
        }

        if (!this.state.BatchId) {
            return;
        }

        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ loading: true, data: [], TotalRecord: 0 });

        var Parameters = {
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
            sortField: this.state.sortField,
            month: this.monthRef.current.value,
            batch: this.state.BatchId,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.RiderPayments_SelectAll,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    //if (resp.data.length > 0) {
                    //    // var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
                    //    // var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                    //    var ProcessedBank = Common.ProcessDataInArray(
                    //        this.state.Banklist,
                    //        "id"
                    //    );
                    //    // var ProcessedTehsil= Common.ProcessDataInArray(this.state.Tehsillist,"id")

                    //    for (var i in resp.data) {
                    //        // resp.data[i].provinceName = ProcessedProvince[resp.data[i].provinceId]?.name
                    //        // resp.data[i].districtName = ProcessedDistrict[resp.data[i].districtId]?.name
                    //        resp.data[i].bankName = ProcessedBank[resp.data[i].bankId]?.name;
                    //    }
                    //}
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.totalRecord,
                    });
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }

                //this.batchRef.current.value = '';
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);

                //this.batchRef.current.value = '';
            }
        );
    };

    onDelete = (id) => {
        this.setState(
            {
                alertModalData: {
                    title: "Delete Rider Profile?",
                    message: "Are you sure you want to delete this record.",
                    First_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                        this.DeleteRecord(id);
                    },
                    Second_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                    },
                    type: 1,
                },
            },
            () => {
                $("#Show_ArletModal").click();
            }
        );
    };

    DeleteRecord = (id) => {
        this.props.ShowLoader({ Isloading: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.BaseUrlAPI + "/api/User/Delete",
            { id, roleId: 4 },
            (resp) => {
                if (resp.status) {
                    this.PopulateTable();
                }
            }
        );
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiderPayments);
